import React from "react";
import { cn } from "./cn";

/* Progress rail for a multi-step flow: one segment per step, filled up to the
   current one. Decorative on its own, so the count is also given as text for
   assistive tech. */
export const StepRail = ({ current = 1, total = 3, className = "" }) => (
  <div className={cn("mt-5", className)}>
    {/* Phones stack the segments into full-width rows: three slivers side by
        side on a 320px viewport are too short to read as progress. From sm up
        they sit in a row, one column per step. */}
    <div
      className="grid gap-4 sm:gap-1.5 grid-cols-1 sm:[grid-template-columns:var(--u1-steps)]"
      style={{ "--u1-steps": `repeat(${total}, minmax(0, 1fr))` }}
      aria-hidden="true"
    >
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={cn(
            "h-1 rounded-full transition-colors",
            i + 1 <= current ? "bg-[var(--orange)]" : "bg-[var(--slate-3)]"
          )}
        />
      ))}
    </div>
    <span className="sr-only">{`Step ${current} of ${total}`}</span>
  </div>
);

export default StepRail;
